import httpClient from '~/http/services/pos';
import { ApiResponse } from '../types/Api';
import { Cashier } from '../types/Cashier';

const CASHIER_URL = '/api/v1/cashier';

type GetCashierResponse = ApiResponse<Cashier>;

let _cashier: Cashier | null = null;

export const fetchCashier = () => {
  return httpClient.get<GetCashierResponse>(`${CASHIER_URL}`);
};

export const getCashier = async (
  params: { refresh: boolean } | undefined = { refresh: false }
) => {
  if (_cashier != null && !params.refresh) return _cashier;
  const { data, error } = await fetchCashier();
  if (!error && data) {
    _cashier = data;
    return data;
  } else {
    throw error;
  }
};
